import React from 'react'
import Api from '../services/ApiService'
import * as Bambora from '@bambora/checkout-sdk-web'
import {
    Typography,
    Table,
    TableBody,
    TableRow,
    TableCell
} from '@material-ui/core'
import Button from './ButtonComponent'

import Input from './InputComponent'

export default class LoginComponent extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            error: false,
            isLoggedIn: false,
            card: {},
            customer: {},
            form: {
                username: '',
                password: '',
                termsAccepted: false
            },
            loadingScreen: {
                isLoading: false,
                text: ''
            }
        }

        this.handleBookingSubmit = this.handleBookingSubmit.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.paymentModal = this.paymentModal.bind(this)
    }

    componentDidMount() {
        if (this.props.customer.email) {
            this.setState({
                isLoggedIn: true,
                customer: this.props.customer
            })
        }
    }

    paymentModal({ customer_id, resource_id, order_id, isExistingUser }) {
        this.setState({
            status: 'requesting_token',
            loadingScreen: {
                text: 'Indlæser betalingsvindue...'
            }
        })

        Api.getPaymentToken({
            resource_id,
            customer_id,
            order_id,
            isExistingUser
        })
            .then(({ token }) => {
                let checkoutModal = new Bambora.ModalCheckout(token)
                checkoutModal.on(Bambora.Event.CardTypeResolve, card => {
                    this.setState({
                        card
                    })
                })

                checkoutModal.on(Bambora.Event.Cancel, () => {
                    this.setState({
                        status: 'ready'
                    })
                    Api.unlockBooking({ customer_id, order_id })
                })

                checkoutModal.on(Bambora.Event.Authorize, payload => {
                    checkoutModal.hide()
                    this.props.onPaymentComplete({
                        customer: this.state.customer,
                        order: payload.data,
                        card: this.state.card,
                        startDate: this.props.startDate,
                        room: this.props.selectedRoom
                    })
                    setTimeout(() => {
                        checkoutModal.destroy()
                    }, 2000)
                })

                checkoutModal.show()
            })
            .catch(error => {
                console.log('getPaymentToken() failed!')
            })
    }

    handleChange(event) {
        let { name: field, value } = event.target

        if (field === 'termsAccepted') {
            value = !this.state.form.termsAccepted
        }

        this.setState(prevState => ({
            form: {
                ...prevState.form,
                [field]: value
            }
        }))
    }

    handleSubmit(event) {
        event.preventDefault()

        let { form } = this.state

        this.setState({
            error: false
        })

        let { username, password } = form

        Api.login({ username, password })
            .then(({ jwt }) => {
                Api.configure({
                    token: jwt
                })

                Api.getCustomerData()
                    .then(customerData => {
                        this.setState({
                            isLoggedIn: true,
                            customer: customerData
                        })
                        this.props.onLogin(customerData)
                    })
                    .catch(e => {
                        console.log(e)
                        this.setState({
                            error: true
                        })
                    })

                this.setState({
                    error: false
                })
            })
            .catch(e => {
                console.log(e)
                this.setState({
                    error: true
                })
            })
    }

    handleBookingSubmit(event) {
        event.preventDefault()
        const { customer } = this.state
        const { selectedRoom, startDate } = this.props

        if (customer.customer_id) {
            Api.createBooking({
                resource_id: selectedRoom.resource_id,
                customer_id: customer.customer_id,
                from_date: startDate.format('YYYY-MM-DD')
            }).then(({ booking_id, order_id }) => {
                this.paymentModal({
                    customer_id: customer.customer_id,
                    resource_id: selectedRoom.resource_id,
                    order_id: order_id,
                    isExistingUser: true
                })
            })
        } else {
            this.setState({
                error: true
            })
        }
    }

    render() {
        let { form, error, isLoggedIn, customer } = this.state

        return (
            <div>
                {!isLoggedIn && (
                    <div>
                        <Typography
                            component="h3"
                            style={{
                                color: '#F06F2F',
                                marginTop: 10,
                                marginBottom: 5,
                                fontWeight: 'bold'
                            }}
                        >
                            Log ind
                        </Typography>
                        <form onSubmit={this.handleSubmit}>
                            <Input
                                id="username"
                                label="E-mail"
                                name="username"
                                value={form.username}
                                onChange={this.handleChange}
                                required
                                fullWidth
                                placeholder="E-mail"
                            />
                            <Input
                                id="password"
                                label="Password"
                                name="password"
                                type="password"
                                value={form.password}
                                onChange={this.handleChange}
                                required
                                fullWidth
                                placeholder="Adgangskode"
                            />

                            {error && (
                                <Typography
                                    component="p"
                                    style={{ marginTop: '1em', color: 'red' }}
                                >
                                    Ugyldigt login
                                </Typography>
                            )}

                            <Button type="submit" style={{ marginTop: '2em' }}>
                                Log ind
                            </Button>
                        </form>
                    </div>
                )}
                {isLoggedIn && (
                    <div>
                        <Typography
                            component="p"
                            style={{
                                color: '#F06F2F',
                                marginTop: 10,
                                marginBottom: 5,
                                fontWeight: 'bold'
                            }}
                        >
                            Dine oplysninger
                        </Typography>
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell>Navn</TableCell>
                                    <TableCell>{customer.name}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Email</TableCell>
                                    <TableCell>{customer.email}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Telefon</TableCell>
                                    <TableCell>
                                        +{customer.country_code}{' '}
                                        {customer.telephone}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Adresse</TableCell>
                                    <TableCell>
                                        {customer.address}, {customer.zipcode}{' '}
                                        {customer.city}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                        <div style={{ marginTop: 10 }}></div>
                        <label
                            style={{
                                cursor: 'pointer',
                                fontSize: 14,
                                fontFamily: 'Montserrat, sans-serif'
                            }}
                        >
                            <input
                                style={{
                                    cursor: 'pointer',
                                    marginRight: 10,
                                    marginTop: 15
                                }}
                                type="checkbox"
                                checked={form.termsAccepted}
                                name="termsAccepted"
                                onChange={this.handleChange}
                            />
                            <span>Acceptér betingelser</span>
                        </label>{' '}
                        <div style={{ marginTop: 30 }}></div>
                        <Button
                            type="submit"
                            disabled={!form.termsAccepted}
                            onClick={this.handleBookingSubmit}
                        >
                            Bestil
                        </Button>
                    </div>
                )}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/LoginComponent.jsx